import instance from "./index";
/**
 * @param {String} method  请求的方法：get、post、delete、put
 * @param {String} url     请求的url:
 * @param {Object} data    请求的参数
 * @param {Object} config  请求的配置
 * @returns {Promise}     返回一个promise对象，其实就相当于axios请求数据的返回值
 */

const post = async ({ url, data, config }) => {
  return instance.post(url,  data, {...config });
};
const get = async ({ url, data, config }) => {
  return instance.get(url, { params: data, ...config });
};
const put = async ({ url, data, config }) => {
  return instance.put(url, data, { ...config });
};
const deleteFun = async ({ url, data, config }) => {
  return instance.delete(url, { params: data, ...config });
};
const postForm = async ({ url, data, config }) => {
  return instance.postForm(url, data, { ...config });
};

export { post, get, put, deleteFun, postForm };
